import * as React from 'react';
import styled from '../../styles/styled-components';

export const Page = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  height: 100%;

  @media (min-width: ${p => p.theme.screenLgMin}) {
    margin: auto;
    float: none !important;
  }
`;

export const PageContent = styled.div`
  padding: 20px;
`;
